'use es6';

import { REGISTER_STATUS_BAR } from 'DesignData/actions/ActionTypes';
export function registerStatusBar(contents) {
  return {
    type: REGISTER_STATUS_BAR,
    contents
  };
}